const cvRouter = [{
		path: '/',
		name: '/',
		redirect: '/cvs'
	},
	{
		path: '/cvs',
		name: 'cvs',
		component: () => import(/* webpackChunkName: "cvs" */ '@/views/cv-index/index')
	},
	{
		path: '/cvs/templates',
		name: 'cv-templates',
		component: () => import(/* webpackChunkName: "cvs" */ '@/views/cv-templates/index')
	},
	{
		path: '/cvs/:token/experience',
		name: 'experience-list',
		component: () => import(/* webpackChunkName: "cvs" */ '@/views/cv-experience/experience-list'),
		meta: {
			isLogin: true
		}
	},
	{
		path: '/cvs/:token/editor',
		name: 'editor',
		component: () => import(/* webpackChunkName: "cvs" */ '@/views/cv-editor/editor'),
		meta: {
			isLogin: true
		}
	},
	{
		path: '/cvs/:token/preview',
		name: 'preview',
		component: () => import(/* webpackChunkName: "cvs" */ '@/views/cv-preview/index'),
		meta: {
			isLogin: true
		}
	},
	{
		path: '/plugin_v/cvs/:token/share',
		name: 'cv-share-plugin',
		component: () => import(/* webpackChunkName: "plugin" */ '@/views/cv-share/index'),
		meta: {
			diffShare: true
		}
	},
	{
		path: '/cvs/:token/share',
		name: 'cv-share',
		component: () => import(/* webpackChunkName: "share" */ '@/views/cv-share/index'),
		meta: {
			diffShare: true
		}
	},
	{
		path: '/share/:token/manage',
		name: 'share-manage',
		component: () => import(/* webpackChunkName: "share" */ '@/views/share-manage/index'),
	},
	{
		path: '/cvs/:token/module',
		name: 'module-manage',
		component: () => import(/* webpackChunkName: "cvs" */ '@/views/cv-module/index'),
		meta: {
			isLogin: true
		}
	},
	{
		path: '/cvs/:token/profiles',
		name: 'profile',
		component: () => import(/* webpackChunkName: "cvs" */ '@/views/cv-editor/profile'),
		meta: {
			isLogin: true
		},

	},
  {
		path: '/cvs/:token/intention-state',
		name: 'intention-state',
		component: () => import(/* webpackChunkName: "mentor" */ '@/views/cv-editor/intention/intentionState'),
		meta: {
			isLogin: true
		}
	},
  {
		path: '/cvs/:token/intention-job',
		name: 'intention-job',
		component: () => import(/* webpackChunkName: "mentor" */ '@/views/cv-editor/intention/intentionJob'),
		meta: {
			isLogin: true
		}
	},
  {
		path: '/cvs/:token/intention-city',
		name: 'intention-city',
		component: () => import(/* webpackChunkName: "mentor" */ '@/views/cv-editor/intention/intentionCity'),
		meta: {
			isLogin: true
		}
	},
	{
		path: '/cvs/:token/:type/:info_id/edit',
		name: 'convention-module',
		component: () => import(/* webpackChunkName: "cvs" */ '@/views/editor-module/module-base/edit'),
		meta: {
			isLogin: true
		}
	},
	{
		path: '/cvs/:token/:type/:info_id/content_edit',
		name: 'convention-module-content',
		component: () => import(/* webpackChunkName: "cvs" */ '@/views/editor-module/module-base/content'),
		meta: {
			// isLogin: true
		}
	},
	{
		path: '/cvs/:token/:custom_id/:type/:info_id/edit',
		name: 'custom-section',
		component: () => import(/* webpackChunkName: "cvs" */ '@/views/editor-module/module-custom/edit'),
		meta: {
			isLogin: true
		}
	},
	{
		path: '/cvs/:token/:custom_id/:type/:info_id/content_edit',
		name: 'custom-section-content',
		component: () => import(/* webpackChunkName: "cvs" */ '@/views/editor-module/module-custom/content'),
		meta: {
			isLogin: true
		}
	},
	{
		path: '/cvs/:token/extras',
		name: 'extras',
		component: () => import(/* webpackChunkName: "cvs" */ '@/views/editor-module/module-other/edit'),
		meta: {
			isLogin: true
		}
	},
	{
		path: '/cvs/:token/extras/label',
		name: 'extras-label',
		component: () => import(/* webpackChunkName: "cvs" */ '@/views/editor-module/module-other/edit-label'),
		meta: {
			isLogin: true
		}
	},
	{
		path: '/cvs/online/list',
		name: 'list',
		component: () => import(/* webpackChunkName: "cvs_online" */ '@/views/cv-online/cv-list'),
		meta: {
			isLogin: true
		}
	},
	{
		path: `/cvs/online/:online_token/base`,
		name: 'base',
		component: () => import(/* webpackChunkName: "cvs_online" */ '@/views/cv-online/base-info'),
		meta: {
			isLogin: true
		}
	},
	{
		path: '/cvs/online/:online_token/edu',
		name: 'edu',
		component: () => import(/* webpackChunkName: "cvs_online" */ '@/views/cv-online/edu-info'),
		meta: {
			isLogin: true
		}
	},
	{
		path: '/cvs/online/:online_token/work',
		name: 'work',
		component: () => import(/* webpackChunkName: "cvs_online" */ '@/views/cv-online/work-info'),
		meta: {
			isLogin: true
		}
	},
	{
		path: '/cvs/online/:online_token/contact',
		name: 'contact',
		component: () => import(/* webpackChunkName: "cvs_online" */ '@/views/cv-online/phone-info'),
		meta: {
			isLogin: true
		}
	},
	{
		path: '/cvs/online/:online_token/success',
		name: 'success',
		component: () => import(/* webpackChunkName: "cvs_online" */ '@/views/cv-online/cv-success'),
		meta: {
			isLogin: true
		}
	},
	{
		path: '/account/privacy',
		name: 'privacy',
		component: () => import(/* webpackChunkName: "account" */ '@/views/cv-online/privacy-set'),
		meta: {
			isLogin: true
		}
	},
	{
		path: '/cvs/online/:online_token/preview',
		name: 'online_preview',
		component: () => import(/* webpackChunkName: "cvs_online" */ '@/views/cv-online/cv-preview'),
		meta: {
			isLogin: true
		}
	},
	{
		path: '/inbox',
		name: 'cv-inbox',
		component: () => import(/* webpackChunkName: "inbox" */ '@/views/cv-inbox/inbox'),
		// meta: {
		// 	isLogin: true
		// }
	},
	{
		path: '/cvs/service-agreement',
		name: 'service-agreement',
		component: () => import(/* webpackChunkName: "cvs" */ '@/views/static-text/service-agreement'),
		meta: {
			isLogin: false
		}
	},
	{
		path: '/cvs/privacy-clause',
		name: 'privacy-clause',
		component: () => import(/* webpackChunkName: "cvs" */ '@/views/static-text/privacy-clause'),
		meta: {
			isLogin: false
		}
	},
  {
		path: '/cvs/service-teach',
		name: 'service-teach',
		component: () => import(/* webpackChunkName: "cvs" */ '@/views/static-text/service-teach'),
    meta: {
			isLogin: false
		}
	},
	{
		path: '/cvs/send-email',
		name: 'send_email',
		component: () => import(/* webpackChunkName: "cvs" */ '@/views/cv-preview/send-email'),
		meta: {
			isLogin: true
		}
	},
	{
		path: '/cvs/send-success',
		name: 'send_success',
		component: () => import(/* webpackChunkName: "cvs" */ '@/views/cv-preview/success'),
		meta: {
			isLogin: true
		}
	},
	{
		path: '/cvs/test/texteditor',
		name: 'text-editor-test',
		component: () => import(/* webpackChunkName: "cvs" */ '@/views/editor-module/text-editor/texteditor'),
		meta: {
			isLogin: false
		}
	},
	{
		path: '/mentor/template',
		name: 'mentor-template',
		component: () => import(/* webpackChunkName: "mentor" */ '@/views/mentor-template/index'),
		meta: {
			isLogin: false
		}
	},
  {
    path: '/lesson',
    name: 'lesson',
    component: () => import(/* webpackChunkName: "mentor" */ '@/views/lesson/index'),
		meta: {
			isLogin: false
		}
  },
	// 问卷首页
	{
		path: '/questionnaire',
		name: 'questionnaire-index',
		component: () => import(/* webpackChunkName: "mentor" */ '@/views/questionnaire/index'),
		meta: {
			isLogin: false
		}
	},
	// 问卷2
	{
		path: '/questionnaire/active',
		name: 'questionnaire-active',
		component: () => import(/* webpackChunkName: "mentor" */ '@/views/questionnaire/active'),
		meta: {
			isLogin: false
		}
	}
]

export default cvRouter
